"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Turnstile = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("./utils");
var _excluded = ["scriptOptions", "options", "siteKey", "onSuccess", "onExpire", "onError", "id", "autoResetOnExpire", "style"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Turnstile = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _config$size, _config$theme, _config$retry, _config$retryInterval;
  var scriptOptions = props.scriptOptions,
    options = props.options,
    siteKey = props.siteKey,
    onSuccess = props.onSuccess,
    onExpire = props.onExpire,
    onError = props.onError,
    id = props.id,
    _props$autoResetOnExp = props.autoResetOnExpire,
    autoResetOnExpire = _props$autoResetOnExp === void 0 ? true : _props$autoResetOnExp,
    style = props.style,
    divProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var config = options !== null && options !== void 0 ? options : {};
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    widgetId = _useState2[0],
    setWidgetId = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    scriptLoaded = _useState4[0],
    setScriptLoaded = _useState4[1];
  var containerRef = (0, _react.useRef)(null);
  var firstRendered = (0, _react.useRef)(false);
  var containerId = id !== null && id !== void 0 ? id : _utils.DEFAULT_CONTAINER_ID;
  var containerSize = (_config$size = config.size) !== null && _config$size !== void 0 ? _config$size : "normal";
  var containerStyle = _utils.CONTAINER_STYLE_SET[containerSize];
  var onLoadCallbackName = (scriptOptions === null || scriptOptions === void 0 ? void 0 : scriptOptions.onLoadCallbackName) || _utils.DEFAULT_ONLOAD_NAME;
  var scriptOptionsJson = JSON.stringify(scriptOptions);
  var configJson = JSON.stringify(config);
  (0, _react.useImperativeHandle)(ref, function () {
    if (typeof window === "undefined") return;
    var _window = window,
      turnstile = _window.turnstile;
    return {
      getResponse: function getResponse() {
        var _window$turnstile;
        if (!window.turnstile || !((_window$turnstile = window.turnstile) !== null && _window$turnstile !== void 0 && _window$turnstile.getResponse) || !widgetId) {
          console.warn("Turnstile has not been loaded");
          return;
        }
        return turnstile === null || turnstile === void 0 ? void 0 : turnstile.getResponse(widgetId);
      },
      reset: function reset() {
        var _window$turnstile2;
        if (!window.turnstile || !((_window$turnstile2 = window.turnstile) !== null && _window$turnstile2 !== void 0 && _window$turnstile2.reset) || !widgetId) {
          console.warn("Turnstile has not been loaded");
          return;
        }
        return turnstile === null || turnstile === void 0 ? void 0 : turnstile.reset(widgetId);
      },
      remove: function remove() {
        var _window$turnstile3, _window$turnstile4;
        if (!window.turnstile || !((_window$turnstile3 = window.turnstile) !== null && _window$turnstile3 !== void 0 && _window$turnstile3.remove) || !widgetId) {
          console.warn("Turnstile has not been loaded");
          return;
        }
        (_window$turnstile4 = window.turnstile) === null || _window$turnstile4 === void 0 ? void 0 : _window$turnstile4.remove(widgetId);
        setWidgetId("");
      },
      render: function render() {
        var _window$turnstile5, _window$turnstile6;
        if (!window.turnstile || !((_window$turnstile5 = window.turnstile) !== null && _window$turnstile5 !== void 0 && _window$turnstile5.render)) {
          console.warn("Turnstile has not been loaded");
          return;
        }
        if (!containerRef.current) {
          console.warn("Container has not rendered");
          return;
        }
        if (widgetId) {
          console.warn("Widget already rendered");
          return widgetId;
        }
        var id = (_window$turnstile6 = window.turnstile) === null || _window$turnstile6 === void 0 ? void 0 : _window$turnstile6.render(containerRef.current, renderConfig);
        setWidgetId(id);
        return id;
      }
    };
  }, [scriptLoaded, typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window), widgetId]);
  var renderConfig = {
    action: config.action,
    cData: config.cData,
    theme: (_config$theme = config.theme) !== null && _config$theme !== void 0 ? _config$theme : "auto",
    sitekey: siteKey,
    tabindex: config.tabIndex,
    callback: onSuccess,
    "expired-callback": onExpire,
    "error-callback": onError,
    size: (0, _utils.getTurnstileSizeOpts)(containerSize),
    "response-field": config.responseField,
    "response-field-name": config.responseFieldName,
    retry: (_config$retry = config.retry) !== null && _config$retry !== void 0 ? _config$retry : "auto",
    "retry-interval": (_config$retryInterval = config.retryInterval) !== null && _config$retryInterval !== void 0 ? _config$retryInterval : 8000
  };
  var onLoadScript = function onLoadScript() {
    setScriptLoaded(true);
  };
  var onLoadScriptError = function onLoadScriptError() {
    console.error("Error loading turnstile script");
  };

  /** define onload function and inject turnstile script */
  (0, _react.useEffect)(function () {
    if (!siteKey) {
      console.warn("sitekey was not provided");
      return;
    }

    // define onLoad function
    window[onLoadCallbackName] = function () {
      if (!firstRendered.current) {
        var _window$turnstile7;
        var _id = (_window$turnstile7 = window.turnstile) === null || _window$turnstile7 === void 0 ? void 0 : _window$turnstile7.render(containerRef === null || containerRef === void 0 ? void 0 : containerRef.current, renderConfig);
        setWidgetId(_id);
        firstRendered.current = true;
      }
    };
    (0, _utils.injectTurnstileScript)({
      render: "explicit",
      onLoadCallbackName: onLoadCallbackName,
      scriptOptions: scriptOptions,
      onLoad: onLoadScript,
      onError: onLoadScriptError
    });
    if (autoResetOnExpire) {
      // expire time it's documented as 300 seconds but can happen in around 290 seconds.
      var timerId = setInterval(function () {
        var _window$turnstile8;
        return (_window$turnstile8 = window.turnstile) === null || _window$turnstile8 === void 0 ? void 0 : _window$turnstile8.reset();
      }, 290 * 1000);
      return function () {
        return clearInterval(timerId);
      };
    }
  }, [configJson, scriptOptionsJson]);
  (0, _react.useEffect)(function rerenderWidget() {
    if (containerRef.current && window.turnstile) {
      var _window2 = window,
        turnstile = _window2.turnstile;
      turnstile.remove(widgetId);
      var _id2 = turnstile.render(containerRef.current, renderConfig);
      setWidgetId(_id2);
      firstRendered.current = true;
    }
  }, [configJson, siteKey]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: containerRef,
    id: containerId,
    style: _objectSpread(_objectSpread({}, containerStyle), style)
  }, divProps));
});
exports.Turnstile = Turnstile;
Turnstile.displayName = "Turnstile";
var _default = Turnstile;
exports["default"] = _default;